module.exports = __webpack_public_path__ + "d3fdbbdf49761ee21923a2aabed892d8.png";